import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/room/mutations'
import { path } from '@/store/room/types'
import { mutation } from '@/utils/mutation'
import state, { IRoomState } from '@/store/room/state'

export * from '@/store/room/state'

export const store: Module<IRoomState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
